import { AvForm } from "availity-reactstrap-validation"
import { Check, CustomDatePicker, CustomSelectAsync, FormSwitch } from "components/Common"
import { InlineEditType, ModuleIds, RESULT_STATE, RESULT_STATE_Text, TestRequest_State, parameterCode, permissionType } from "constant"
import { getCodesByParameterId } from "helpers/app-backend"
import { convertDateFormat, getI18nextLng } from "helpers/utilities"
import { isEmpty } from "lodash"
import * as moment from "moment"
import PropTypes from "prop-types"
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import {
    ChangeRequestSampleTable, getTestRequestSample,
    samplePatientVisitChange
} from "store/laboratory/testRequest/actions"
import SampleTabTable from "./SampleTabTable"

let lang = getI18nextLng()
const RESOURCE = ModuleIds.PatientVisit;
const SampleTab = forwardRef(({
    t,
    testRequestSample,
    onGetTestRequestSample,
    activeTab,
    onChangeRequestSampleTableSuccess,
    onChangeCollect,
    onChange,
    testRequest,
    generalSetting,
    onSaveSample,
    config,
    patientVisitTab,
    testRequestTestsOld,
    testRequestSampleOld,
    testRequestTests,
    onSamplePatientVisitChange
}, ref) => {
    const [isCollected, setIsCollected] = useState(false);
    const [isReceived, setIsReceived] = useState(false);
    const [dataCollect, setDataCollect] = useState([]);
    const [dataReceive, setDataReceive] = useState([]);

    const [userCollect, setUserCollect] = useState(0)
    const [userReceive, setUserReceive] = useState(0)
    const [receiveDate, setReceiveDate] = useState(new Date())
    const [collectDate, setCollectDate] = useState(new Date())
    const [userCollectName, setUserCollectName] = useState('');
    const [userReceiveName, setUserReceiveName] = useState('');
    const [lstQuanlity, setLstQuanlity] = useState([])
    const [defaultCollector, setDefaultCollect] = useState()

    let userInfo = localStorage.getItem("userInfo")
    // const defaultCollector = JSON.parse(localStorage.getItem("defaultCollector"))
    let { family_name, given_name, name, sub } = JSON.parse(userInfo)

    let defaultCollectObj = localStorage.getItem("defaultCollector")
    useEffect(() => {
        const collectorObj = defaultCollectObj ? JSON.parse(defaultCollectObj) : {}
        setDefaultCollect(collectorObj)
    }, [defaultCollectObj])

    useEffect(() => {
        onChangeCollect && onChangeCollect(isCollected)
    }, [isCollected])


    useEffect(() => {
        // if (testRequestSample.length > 0) {
        //     const isCollect = testRequestSample.findIndex(x => x.collectorUserId != undefined && x.collectorUserId != null && x.collectorUserId != '')
        //     setIsCollected(isCollect >= 0)
        //     const isReceiver = testRequestSample.findIndex(x => x.receiverUserId != undefined && x.receiverUserId != null && x.receiverUserId != '')
        //     setIsReceived(isReceiver >= 0)
        //     if (!isCollectedAndClear) {
        //         setIsCollected(true);
        //     } else {
        //         setIsCollected(false);
        //     }
        // }
        // else {
        //     setIsCollected(false);
        //     setIsReceived(false);
        // }
        if (testRequestSample.length > 0) {
            const isCollect = testRequestSample.filter(x => (!x.isClear || (x.collectorUserId == undefined || x.collectorUserId == null || x.collectorUserId == '')) && x.state != 2)
            setIsCollected(isCollect.length == 0)
            const isCheck = testRequestSample.filter(x => x.isCollected == true && x.state != 2)
            if (isCheck.length == 0) {
                let isChange = checkChangeData()
                onChange && onChange(isChange, testRequestSample)
            }
            const isReceiver = testRequestSample.filter(x => (!x.isClear || (x.receiverUserId == undefined || x.receiverUserId == null || x.receiverUserId == '')) && x.state != 2).length
            setIsReceived(isReceiver == 0)
        }
        else {
            setIsCollected(false);
            setIsReceived(false);
        }
    }, [testRequestSample])

    useEffect(() => {
        if (activeTab == 3) {
            onGetTestRequestSample()
        }
    }, [activeTab])
    useImperativeHandle(ref, () => ({
        GetUserData: () => {
            let res = {}
            let displayName = '';
            let userid = 0
            if (userInfo) {
                displayName = family_name && given_name ? `${family_name} ${given_name}` : name
                userid = defaultCollector ? parseInt(defaultCollector?.collectorId) : Number(sub)
            }
            if (isCollected) {
                if (!isEmpty(userCollectName)) {
                    res.userCollectName = userCollectName
                    res.userCollect = userCollect
                    res.isCollected = true
                    res.collectionTime = collectDate
                }
                else {
                    res.userCollectName = defaultCollector ? defaultCollector?.collectorName : displayName
                    res.userCollect = userid
                    res.isCollected = true
                    res.collectionTime = collectDate
                }
            }
            else {
                res.userCollectName = ''
                res.userCollect = 0
                res.isCollected = false
            }
            if (isReceived) {
                if (!isEmpty(userReceiveName)) {
                    res.userReceiveName = userReceiveName
                    res.userReceive = userReceive
                    res.isReceived = true
                    res.receivedTime = receiveDate
                }
                else {
                    res.userCollectName = defaultCollector ? defaultCollector?.collectorName : displayName
                    res.userCollect = userid
                    res.isReceived = true
                    res.receivedTime = receiveDate
                }
            }
            else {
                res.userReceiveName = ''
                res.userReceive = 0
                res.isReceived = false
            }
            return res;
        },
    }));

    useEffect(() => {
        // const displayName = family_name && given_name ? `${family_name} ${given_name}` : name
        const displayName = family_name ? `${family_name} ${given_name}` : name
        // if (defaultCollector) {
        //     // setUserCollect(Object.keys(defaultCollector).length !== 0 ? parseInt(defaultCollector?.collectorId) : Number(sub))
        //     // setUserCollectName(Object.keys(defaultCollector).length !== 0 ? defaultCollector?.collectorName : displayName)
        // } else {
        //     setUserCollect(Number(sub))
        //     setUserCollectName(displayName)
        // }
        setUserCollect(Number(sub))
        setUserCollectName(displayName)
    }, [testRequest, defaultCollector, patientVisitTab])

    useEffect(() => {
        if (userInfo) {
            const displayName = family_name && given_name ? `${family_name} ${given_name}` : name
            const res = [{ value: defaultCollector ? parseInt(defaultCollector?.collectorId) : Number(sub), label: displayName }]
            setUserReceive(Number(sub))
            setUserReceiveName(displayName)
            setDataCollect(res)
            setDataReceive(res)
        }
        getQuanlity();
    }, [])

    const getQuanlity = async () => {
        const query = { lang }
        const res = await getCodesByParameterId(parameterCode.TESTREQUEST_SAMPLE_QUALITY, query)
        res?.map(_item => {
            _item.value = _item.code
            _item.label = _item.message
            return _item
        })
        setLstQuanlity(res)
    }
    const afterSubmit = (forceChange) => {
        let isChange = checkChangeData(forceChange)
        onChange && onChange(isChange, testRequestSample)
    }

    const checkChangeData = (forceChange) => {
        if (forceChange == true) {
            return true
        }
        if (testRequestSample.length != testRequestSampleOld.length) {
            return true
        }
        if (testRequestTests.length != testRequestTestsOld.length) {
            return true
        }
        //check sample
        if (testRequestSample.length > 0 && testRequestSample.filter(x => x.isCollected == true
            && (x.state == RESULT_STATE_Text.Submitted || x.state == RESULT_STATE_Text.OnHold || x.state == RESULT_STATE_Text.RDS)).length > 0) {
            return true
        }
        //check test
        for (let index = 0; index < testRequestTestsOld.length; index++) {
            const element = testRequestTestsOld[index];
            if (element.state != RESULT_STATE_Text.Canceled) {
                const itemCompare = testRequestTests.find(x => x.id == element.id && x.state != RESULT_STATE_Text.Canceled)
                if (itemCompare == null) {
                    return true
                }
            }
        }
        return false;
    }

    const displayCollected = generalSetting.find(item => item.fieldName === 'Collected')?.fieldValue === 'True'
    return (
        <React.Fragment>
            {displayCollected && <AvForm id="generalForm" >
                <Row className="px-2 mt-2">
                    <Col md={12}>
                        <div className="row">
                            {patientVisitTab == 2 && <div className="my-1" style={{ alignSelf: 'center', width: '146px' }}>
                                <FormSwitch label={t("testRequestPage:Collected?")}
                                    // disabled={!testRequestSample?.some(sample => 
                                    //     testRequest.state == TestRequest_State.Onhold 
                                    //     ||(sample.state < TestRequest_State.Collected && sample.state != RESULT_STATE_Text.Canceled)
                                    // )}
                                    disabled={testRequest.state >= TestRequest_State.Collected && testRequest.state != TestRequest_State.Onhold}
                                    value={isCollected}
                                    onChangeSwitch={(e) => {
                                        if (e) {
                                            onSamplePatientVisitChange({ isCollect: e, sample: [], samples: testRequestSample })
                                        } else {
                                            onSamplePatientVisitChange({ isCollect: e, sample: [], samples: [] })
                                        }

                                        if (isCollected) {
                                            setIsReceived(false)
                                            onChangeRequestSampleTableSuccess([
                                                { value: !isCollected, key: 'isCollected' },
                                                { value: null, key: 'collectionTime' },
                                                { value: null, key: 'collectorUserId' },
                                                { value: '', key: 'collectorName' },
                                                { value: false, key: 'isReceived' },
                                                { value: null, key: 'receivedTime' },
                                                { value: null, key: 'receiverUserId' },
                                                { value: '', key: 'receiverName' },
                                                { value: ' ', key: 'quality' },
                                                { value: '', key: 'qualityName' },
                                                { value: false, key: 'isClear' },
                                            ], () => afterSubmit(e))
                                        }
                                        else {
                                            let collectedDateString = moment(collectDate).format("YYYY-MM-DDTHH:mm");
                                            onChangeRequestSampleTableSuccess([
                                                { value: !isCollected, key: 'isCollected' },
                                                { value: collectedDateString, key: 'collectionTime' },
                                                { value: userCollect, key: 'collectorUserId' },
                                                { value: userCollectName, key: 'collectorName' },
                                                { value: 'G', key: 'quality' },
                                                { value: true, key: 'isClear' },
                                                { value: lstQuanlity.find(x => x.value == "G")?.label, key: 'qualityName' },
                                            ], () => afterSubmit(e))
                                        }
                                        setIsCollected(prev => !prev)
                                    }}
                                />
                            </div>}
                            {patientVisitTab == 2 && <Check permission={permissionType.CollectedTime} resource={RESOURCE}>
                                <div className="col-md-3 my-1">
                                    <CustomDatePicker
                                        name="collectDate"
                                        // label={''}
                                        placeholder={"DD/MM/YYYY"}
                                        format={"DD/MM/YYYY"}
                                        // value={collectDate || new Date()}
                                        value={convertDateFormat((collectDate || new Date()), 'HH:mm DD-MM-YYYY')}
                                        disabled={testRequest.state >= TestRequest_State.Collected && testRequest.state != TestRequest_State.Onhold}
                                        enableTime={true}
                                        dateFormat={'H:i d-m-Y'}
                                        onChangeHandler={(e) => {
                                            let value = moment(e.time[0]).format("YYYY-MM-DDTHH:mm");
                                            setCollectDate(value)
                                            onChangeRequestSampleTableSuccess([{ value: value, key: 'collectionTime' }])
                                        }}
                                    />
                                </div>
                            </Check>}
                            {patientVisitTab != '3' && <div className="col-md-3 my-1">
                                <CustomSelectAsync
                                    isClearable={false}
                                    label={""}
                                    name="collectName"
                                    readOnly={testRequest.state >= TestRequest_State.Collected && testRequest.state != TestRequest_State.Onhold}
                                    // readOnly={true}
                                    options={dataCollect}
                                    value={userCollect || ""}
                                    // valueName={userCollectName || ''}
                                    code={InlineEditType.TESTREQUEST_SAMPLE_COLLECTOR}
                                    onChange={(e, values, name) => {
                                        setUserCollect(values[0] || null)
                                        setUserCollectName(name || '')
                                        onChangeRequestSampleTableSuccess([{ value: values[0], key: 'collectorUserId' }, { value: name, key: 'collectorName' }])
                                    }}
                                />
                            </div>}
                            {/* <div style={{
                                width: '38%',
                                textAlign: 'right'
                            }}>
                                <CustomButton
                                    text={t("common:Save")}
                                    type="submit"
                                    isEdit
                                    color="success"
                                    className="save-user button-width"
                                    disabled={testRequest === null}
                                    style={{ marginTop: '6px' }}
                                    onClick={() => {
                                        onSaveSample()
                                    }}
                                >
                                    {t("common:Save")}
                                </CustomButton>
                            </div> */}
                        </div>
                    </Col>
                </Row>
            </AvForm>}
            <div className="sampleTabTable px-2">
                <SampleTabTable
                    data={testRequestSample || []}
                    onSelect={() => { }}
                    onSelectAll={() => { }}
                    onDelete={() => { }}
                    userCollect={userCollect}
                    userCollectName={userCollectName}
                    isCollected={isCollected}
                    lstQuanlity={lstQuanlity}
                    patientVisitTab={patientVisitTab}
                    onChange={(value) => {
                        let isChange = checkChangeData(value)
                        onChange && onChange(isChange, testRequestSample)
                    }}
                />
            </div>
        </React.Fragment>
    )
})

SampleTab.propTypes = {
    t: PropTypes.any,
    onGetTestRequestSample: PropTypes.func,
    testRequestSample: PropTypes.array,
    config: PropTypes.any,
    onSaveSample: PropTypes.func
}

SampleTab.defaultProps = {}

const mapStateToProps = ({ testRequest, generalSetting }) => ({
    testRequestSample: testRequest.testRequest.samples || [],
    testRequestTests: testRequest.testRequest.tests || [],
    testRequestSampleOld: testRequest.testRequestOldValue.samples || [],
    testRequestTestsOld: testRequest.testRequestOldValue.tests || [],
    generalSetting: generalSetting.generalSetting
})

const mapDispatchToProps = dispatch => ({
    onGetTestRequestSample: (payload, callback) => dispatch(getTestRequestSample(payload, callback)),
    onChangeRequestSampleTableSuccess: (payload, callback) => dispatch(ChangeRequestSampleTable(payload, callback)),
    onSamplePatientVisitChange: (payload) => dispatch(samplePatientVisitChange(payload))
})
SampleTab.displayName = 'SampleTab';
export default withTranslation(["message", "common", "testRequestPage"], { withRef: true })(connect(
    mapStateToProps,
    mapDispatchToProps, null, { forwardRef: true }
)(SampleTab))
